import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import {
  AffiliateMovementPendingPaginatedDTO,
  ErrorDetails,
} from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';

export class GetAffiliateMovementPendingPaginatedCommand extends IRequestCommand<
  IgetAffiliateMovementPendingPaginatedResponse,
  ErrorDetails,
  IgetAffiliateMovementPendingPaginatedCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'affiCheckingAccount/{checkingAccId}/getMovementPendingPaginated?';

  public override setParameters(
    parameters: IgetAffiliateMovementPendingPaginatedCommandParameters
  ) {
    this._commandUrl = this._commandUrl.replace(
      '{checkingAccId}',
      parameters.checkingAccId.toString()
    );

    this._commandUrl = this._commandUrl.concat(
      parameters.affiliateId && parameters.affiliateId.toString().length > 0
        ? `affiliateId=${parameters.affiliateId}`
        : ''
    );

    this._commandUrl = this._commandUrl.concat(
      parameters.dateTo && parameters.dateTo.toString().length > 0
        ? `&dateTo=${parameters.dateTo}`
        : ''
    );

    this._commandUrl = this._commandUrl.concat(
      parameters.page && parameters.page.toString().length > 0
        ? `&page=${parameters.page}`
        : '&page=1'
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.size && parameters.size.toString().length > 0
        ? `&size=${parameters.size}`
        : '&size'
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.column && parameters.column.toString().length > 0
        ? `&column=${parameters.column}`
        : '&column='
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.sort && parameters.sort.toString().length > 0
        ? `&sort=${parameters.sort}`
        : '&sort'
    );
  }
}

export interface IgetAffiliateMovementPendingPaginatedCommandParameters
  extends ICommandParameters {
  dateTo?: Date;
  affiliateId?: number;
  page?: number;
  size?: number;
  column?: string;
  sort?: string;
  checkingAccId: number;
}

export interface IgetAffiliateMovementPendingPaginatedResponse
  extends AffiliateMovementPendingPaginatedDTO,
    ICommandResponse {}
